import {
    Component,
    AfterViewInit,
    OnInit,
    ViewChild,
    inject,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    AnalyticPlatform,
    SaleAnalyticService,
    MessageType,
    NotificationService,
    UtilService,
} from 'src/app/shared/services';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { map as _map, isEmpty as _isEmpty } from 'lodash';
import { DxDataGridComponent } from 'devextreme-angular';
import { DxButtonGroupComponent } from 'devextreme-angular/ui/button-group';
import { DxDataGridComponent as DxDataGridComponent_1 } from 'devextreme-angular/ui/data-grid';
import {
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxiColumnComponent,
} from 'devextreme-angular/ui/nested';
import { DxTemplateDirective } from 'devextreme-angular/core';
import { FormatRelativeDatetimePipe } from '../../../shared/pipes/format-relative-datetime.pipe';
import { FormatNumberPipe } from '../../../shared/pipes/format-number.pipe';

@Component({
    selector: 'app-sale-time',
    templateUrl: './sale-time.component.html',
    styleUrls: ['./sale-time.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DxButtonGroupComponent,
        DxDataGridComponent_1,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        FormatRelativeDatetimePipe,
        FormatNumberPipe,
    ],
})
export class SaleTimeComponent implements AfterViewInit, OnInit {
    private notificationService = inject(NotificationService);
    private saleAnalyticService = inject(SaleAnalyticService);
    private utilService = inject(UtilService);

    @ViewChild('dataGrid', { static: true })
    private dataGrid!: DxDataGridComponent;

    PLATFORM_OPTIONS = [
        { id: AnalyticPlatform.LnwShop, text: 'LnwShop' },
        { id: AnalyticPlatform.Lazada, text: 'Lazada' },
        { id: AnalyticPlatform.Shopee, text: 'Shopee' },
        { id: AnalyticPlatform.TikTokShop, text: 'TikTok' },
    ];

    saleSource: object[] = [];
    // All platforms selected = the lambdas skip the order join and include
    // legacy sales with no resolvable order (DOWNSTREAM-NOTES.md §3), so
    // per-platform figures won't sum to the all-platforms totals.
    selectedPlatforms: AnalyticPlatform[] = _map(this.PLATFORM_OPTIONS, 'id');

    private fetchSaleReportSubject = new Subject();

    ngOnInit(): void {
        this.fetchSaleReportSubject
            .pipe(
                switchMap(() => {
                    this.dataGrid.instance.beginCustomLoading('');
                    return this.getFetchSaleReportObservable();
                }),
            )
            .subscribe(
                (results) => {
                    this.saleSource = results;
                    this.dataGrid.instance.endCustomLoading();
                },
                (err) => {
                    console.error(err);
                    this.dataGrid.instance.endCustomLoading();
                    this.notificationService.pushMessage({
                        displayTime: 6000,
                        message: this.utilService.errorToString(err),
                        messageType: MessageType.error,
                    });
                },
            );
    }

    ngAfterViewInit(): void {
        this.fetchSaleReportSubject.next();
    }

    platformSelectionChanged(): void {
        if (_isEmpty(this.selectedPlatforms)) {
            this.selectedPlatforms = _map(this.PLATFORM_OPTIONS, 'id');
        }
        this.fetchSaleReportSubject.next();
    }

    private getFetchSaleReportObservable() {
        return this.saleAnalyticService.get(this.selectedPlatforms);
    }
}
